import { fuseDark, lbBrand, lbGray } from '@fuse/colors';
import { lightBlue, red } from '@material-ui/core/colors';

const themesConfig = {
  default: {
    palette: {
      type: 'light',
      primary: {
        light: lbBrand.redLight,
        main: lbBrand.red,
        dark: lbBrand.redDark,
        contrastText: '#FFFFFF',
      },
      secondary: {
        light: lbBrand.neutralText,
        main: lbBrand.darkGray,
        dark: lbBrand.black,
        contrastText: '#FFFFFF',
      },
      success: {
        main: lbBrand.success,
        contrastText: '#FFFFFF',
      },
      warning: {
        main: lbBrand.warning,
        contrastText: '#FFFFFF',
      },
      background: {
        paper: lbGray['50'],
        default: lbBrand.offWhite,
      },
      error: red,
    },
    status: {
      danger: 'orange',
    },
    overrides: {
      MuiTableCell: {
        head: {
          backgroundColor: lbBrand.surface,
          color: `${lbBrand.black} !important`,
          borderBottom: `2px solid ${lbBrand.red}`,
        },
        stickyHeader: {
          backgroundColor: lbBrand.surface,
          borderBottom: `2px solid ${lbBrand.red}`,
        },
      },
      MuiAppBar: {
        colorPrimary: {
          backgroundColor: lbBrand.surface,
          color: lbBrand.black,
          borderBottom: `2px solid ${lbBrand.red}`,
        },
      },
      MuiButton: {
        containedPrimary: {
          backgroundImage: lbBrand.buttonGradient,
          boxShadow: lbBrand.buttonShadow,
          color: lbBrand.white,
          '&:hover': {
            backgroundImage: lbBrand.buttonGradientHover,
            boxShadow: lbBrand.buttonShadow,
          },
        },
      },
      MuiPaper: {
        elevation1: {
          backgroundColor: lbBrand.white,
          boxShadow: lbBrand.cardShadow,
        },
      },
      MuiAutocomplete: {
        paper: {
          boxShadow:
            '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
        },
      },
      MuiOutlinedInput: {
        root: {
          '&$focused $notchedOutline': {
            borderColor: lbBrand.black,
          },
        },
      },
      MuiFormLabel: {
        root: {
          '&$focused': {
            color: lbBrand.black,
          },
        },
      },
      MuiCheckbox: {
        root: {
          color: lbBrand.black,
        },
        colorSecondary: {
          '&$checked': {
            color: lbBrand.black,
          },
        },
        colorPrimary: {
          '&$checked': {
            color: lbBrand.black,
          },
        },
      },
      MuiRadio: {
        root: {
          color: lbBrand.black,
        },
        colorSecondary: {
          '&$checked': {
            color: lbBrand.black,
          },
        },
        colorPrimary: {
          '&$checked': {
            color: lbBrand.black,
          },
        },
      },
      MuiSwitch: {
        colorSecondary: {
          '&$checked': {
            color: lbBrand.success,
          },
          '&$checked + $track': {
            backgroundColor: lbBrand.success,
          },
        },
        colorPrimary: {
          '&$checked': {
            color: lbBrand.success,
          },
          '&$checked + $track': {
            backgroundColor: lbBrand.success,
          },
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: lbBrand.black,
        },
      },
      MuiCircularProgress: {
        colorPrimary: {
          color: lbBrand.black,
        },
        colorSecondary: {
          color: lbBrand.black,
        },
      },
      MuiLinearProgress: {
        barColorPrimary: {
          backgroundColor: lbBrand.black,
        },
        barColorSecondary: {
          backgroundColor: lbBrand.black,
        },
        colorPrimary: {
          backgroundColor: 'rgba(0, 0, 0, 0.15)',
        },
        colorSecondary: {
          backgroundColor: 'rgba(0, 0, 0, 0.15)',
        },
      },
    },
  },
  legacy: {
    palette: {
      type: 'light',
      primary: fuseDark,
      secondary: {
        light: lightBlue[400],
        main: lightBlue[600],
        dark: lightBlue[700],
      },
      background: {
        paper: '#FFFFFF',
        default: '#F7F7F7',
      },
      error: red,
    },
    status: {
      danger: 'orange',
    },
  },
};

export default themesConfig;
